export function normalizeText(value: string): string {
  if (!value) return value;
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}
